import type { TriggerRenderer } from "../types";
import { renderTriggerRenderer } from "./common";

export const onDeployTriggerRenderer: TriggerRenderer = renderTriggerRenderer;
